import { set } from "@kofile/redux-lenses";
import { types } from "../actions/county";
import * as lenses from "../lenses";

const { county } = lenses;

export default {
  [types.SET]: [set(county).with(({ payload }) => payload)]
};
